import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminPanelComponent } from './admin/admin-panel/admin-panel.component';
import { BasketComponent } from './basket/basket.component';
import { DownloadComponent } from './download/download.component';
import { NotFoundComponent } from './errors/not-found/not-found.component';
import { ServerErrorComponent } from './errors/server-error/server-error.component';
import { TestErrorsComponent } from './errors/test-errors/test-errors.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { HomeComponent } from './home/home.component';
import { ImportComponent } from './import/import.component';
import { ListsComponent } from './lists/lists.component';
import { MemberDetailComponent } from './members/member-detail/member-detail.component';
import { OrderhistoryComponent } from './orderhistory/orderhistory.component';
import { OrdersendComponent } from './ordersend/ordersend.component';
import { PricelistComponent } from './pricelist/pricelist.component';
import { ProfileComponent } from './profile/profile.component';
import { PromotionComponent } from './promotion/promotion.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ThankyouComponent } from './thankyou/thankyou/thankyou.component';
import { AdminGuard } from './_guards/admin.guard';
import { AuthGuard } from './_guards/auth.guard';
import { PreventUnsavedChangesGuard } from './_guards/prevent-unsaved-changes.guard';

const routes: Routes = [
  { path:'', component: HomeComponent},
  {
    path: '',
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
    children: [
      { path:'pricelist', component: PricelistComponent},
      { path:'order', component: BasketComponent},
      { path:'download', component: DownloadComponent},
      { path:'members/:username', component: MemberDetailComponent},
      { path:'profile', component: ProfileComponent},
      { path:'lists', component: ListsComponent},
      { path:'import', component: ImportComponent},
      { path:'ordersend', component: OrdersendComponent},
      { path:'orderhistory', component: OrderhistoryComponent},
      { path:'promotion', component: PromotionComponent},
      { path:'admin', component: AdminPanelComponent, canActivate: [AdminGuard]},
    ]
  },
  { path:'errors', component: TestErrorsComponent},
  { path: 'not-found', component: NotFoundComponent},
  { path: 'server-error', component: ServerErrorComponent},
  { path: 'thankyou', component: ThankyouComponent},
  { path:'resetpassword', component: ResetPasswordComponent},
  { path:'forgotpassword', component: ForgotPasswordComponent},
  { path:'**', component: NotFoundComponent, pathMatch: 'full'}, 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
